<mat-card class="container">
  <mat-card-title>{{ 'closed' | transloco }}</mat-card-title>
</mat-card>
